import React from "react";
import './AllProductBanner.css'
const AllProductBanner = () => {
  return (
    <div className='profile-banner-container'>
            <div className="profile-banner">
                <img src={require('../../../images/deals/deal5.jpg')} className='h-100 w-100' alt="" />
                <div className="profile-banner-text">
                    <h1>All Products</h1>
                </div>
            </div>
        </div>
  );
};

export default AllProductBanner;
